/* ==========================================================================
   Baby Star Campus Reviewer Program: shared page helpers
   Loaded by templates/page.campus-reviewer.liquid on all four CRP pages.
   Exposes window.CRP. Page specific logic lives in each page's own inline
   <script> (in the Shopify page body_html).
   ========================================================================== */
(function (w, d) {
  'use strict';

  var CRP = {};

  /* ---- Klaviyo client (browser) API -------------------------------------- */
  CRP.COMPANY_ID = 'YqCnat';
  CRP.REVISION = '2025-07-15';
  CRP.CLIENT_BASE = 'https://a.klaviyo.com/client/';
  CRP.LIST_APPLICANTS = 'YzhKBQ';
  CRP.LIST_CONFIRMED = 'XWgGZd';
  CRP.LIST_MARKETING = 'UmLPcd';
  CRP.SUPPORT_EMAIL = 'info@babystarramen.com';

  CRP.endpoint = function (path) {
    return CRP.CLIENT_BASE + path + '/?company_id=' + CRP.COMPANY_ID;
  };

  /* One POST. Klaviyo answers 202 on success. */
  CRP.post = function (path, payload) {
    return fetch(CRP.endpoint(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': CRP.REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.ok || res.status === 202) { return true; }
      throw new Error('status ' + res.status);
    });
  };

  /* Same POST, retried once. Klaviyo occasionally drops the first call. */
  CRP.postRetry = function (path, payload) {
    return CRP.post(path, payload).catch(function () {
      return CRP.post(path, payload);
    });
  };

  /* Add a profile to a list. properties / customSource optional.
     extra lets a caller merge in a subscriptions block for marketing consent. */
  CRP.subscribe = function (opts) {
    var attrs = { email: opts.email };
    if (opts.first_name) { attrs.first_name = opts.first_name; }
    if (opts.last_name) { attrs.last_name = opts.last_name; }
    if (opts.properties) { attrs.properties = opts.properties; }
    if (opts.subscriptions) { attrs.subscriptions = opts.subscriptions; }

    return CRP.postRetry('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: opts.custom_source || 'Campus Reviewer Program',
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: opts.list } } }
      }
    });
  };

  /* Create or update a profile without touching list membership. */
  CRP.profile = function (attrs) {
    return CRP.postRetry('profiles', {
      data: { type: 'profile', attributes: attrs }
    });
  };

  /* Fire a custom metric against a profile. */
  CRP.event = function (metricName, properties, profileAttrs) {
    return CRP.postRetry('events', {
      data: {
        type: 'event',
        attributes: {
          properties: properties,
          metric: { data: { type: 'metric', attributes: { name: metricName } } },
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        }
      }
    });
  };

  /* ---- URL helpers -------------------------------------------------------- */
  CRP.param = function (name) {
    /* the template strips ?email= from the address bar before any pixel loads and keeps the original query here */
    var search = (typeof w.__crpQuery === 'string' && w.__crpQuery) ? w.__crpQuery : w.location.search;
    var m = search.match(new RegExp('[?&]' + name + '=([^&]*)'));
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : null;
  };

  /* utm_source / utm_medium / utm_campaign / utm_content, only the ones actually present. */
  CRP.utm = function () {
    var out = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      var v = CRP.param(k);
      if (v) { out[k] = v.trim(); }
    });
    return out;
  };

  CRP.prefillEmail = function (input) {
    var el = typeof input === 'string' ? d.getElementById(input) : input;
    if (!el) { return null; }
    var q = CRP.param('email');
    if (q && CRP.isEmail(q)) { el.value = q.trim(); }
    return el.value;
  };

  /* ---- validation --------------------------------------------------------- */
  CRP.isEmail = function (v) {
    return !!v && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());
  };

  /* "@handle", "handle", "instagram.com/handle/" all become "handle". */
  CRP.handle = function (v) {
    if (!v) { return ''; }
    var s = String(v).trim();
    s = s.replace(/^https?:\/\/(www\.)?(instagram|tiktok)\.com\//i, '');
    s = s.replace(/[?#].*$/, '').replace(/\/+$/, '');
    s = s.replace(/^@+/, '').trim();
    return s;
  };

  CRP.digits = function (v) {
    return String(v || '').replace(/[^0-9]/g, '');
  };

  /* (555) 555-5555 as the reader types, without fighting deletions. */
  CRP.formatPhone = function (v) {
    var n = CRP.digits(v).slice(0, 10);
    if (n.length < 4) { return n; }
    if (n.length < 7) { return '(' + n.slice(0, 3) + ') ' + n.slice(3); }
    return '(' + n.slice(0, 3) + ') ' + n.slice(3, 6) + '-' + n.slice(6);
  };

  CRP.bindPhone = function (el) {
    if (!el) { return; }
    el.addEventListener('input', function () {
      var pos = el.value.length - el.selectionStart;
      el.value = CRP.formatPhone(el.value);
      if (pos > 0) {
        try { el.selectionStart = el.selectionEnd = el.value.length - pos; } catch (e) {}
      }
    });
  };

  CRP.isSocialPost = function (v) {
    var s = String(v || '').trim();
    if (!/^https?:\/\//i.test(s)) { return false; }
    return /^https?:\/\/([a-z0-9-]+\.)*(instagram\.com|tiktok\.com)(\/|$)/i.test(s);
  };

  /* ---- form error plumbing ------------------------------------------------ */
  CRP.clearErrors = function (form, boxId) {
    Array.prototype.forEach.call(form.querySelectorAll('.msg'), function (m) { m.parentNode.removeChild(m); });
    Array.prototype.forEach.call(form.querySelectorAll('.is-bad'), function (i) { i.classList.remove('is-bad'); });
    if (boxId) {
      var box = d.getElementById(boxId);
      if (box) { box.className = 'errbox'; box.innerHTML = ''; }
    }
  };

  CRP.fieldError = function (el, message) {
    var target = el.parentElement && el.parentElement.classList.contains('at') ? el.parentElement : el;
    target.classList.add('is-bad');
    var s = d.createElement('span');
    s.className = 'msg';
    s.textContent = message;
    (target.parentElement || target).appendChild(s);
  };

  CRP.focusFirstError = function (form) {
    var bad = form.querySelector('.is-bad');
    if (!bad) { return; }
    var input = bad.tagName === 'INPUT' || bad.tagName === 'SELECT' || bad.tagName === 'TEXTAREA'
      ? bad : bad.querySelector('input,select,textarea');
    try { (input || bad).focus({ preventScroll: true }); } catch (e) {}
    try { bad.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  };

  CRP.showFallbackError = function (boxId, lead) {
    var box = d.getElementById(boxId);
    if (!box) { return; }
    box.innerHTML = '<strong>' + (lead || 'That did not go through.') + '</strong><br>' +
      'An ad blocker or a strict privacy setting usually causes this. Turn the blocker off for this page and try again, ' +
      'or email us at <a href="mailto:' + CRP.SUPPORT_EMAIL + '">' + CRP.SUPPORT_EMAIL + '</a> and we will sort it out by hand.';
    box.className = 'errbox is-on';
    try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  };

  /* ---- button + state helpers -------------------------------------------- */
  CRP.sending = function (btn, label) {
    if (!btn) { return function () {}; }
    var original = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = label || 'Sending...';
    return function restore() {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = original;
    };
  };

  /* Toggle one of a set of .state blocks. */
  CRP.showState = function (ids, activeId) {
    ids.forEach(function (id) {
      var el = d.getElementById(id);
      if (el) { el.className = 'state' + (id === activeId ? ' is-on' : ''); }
    });
    var on = d.getElementById(activeId);
    if (on) {
      on.setAttribute('tabindex', '-1');
      try { on.focus({ preventScroll: true }); } catch (e) {}
      try { w.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
    }
  };

  /* Honeypot: a filled hidden field means a bot. Caller fakes success. */
  CRP.isBot = function (form) {
    var hp = form.querySelector('[name="website_url"]');
    return !!(hp && hp.value.trim());
  };

  /* ---- US states ---------------------------------------------------------- */
  CRP.STATES = [
    ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'],
    ['CA', 'California'], ['CO', 'Colorado'], ['CT', 'Connecticut'], ['DE', 'Delaware'],
    ['DC', 'District of Columbia'], ['FL', 'Florida'], ['GA', 'Georgia'], ['HI', 'Hawaii'],
    ['ID', 'Idaho'], ['IL', 'Illinois'], ['IN', 'Indiana'], ['IA', 'Iowa'],
    ['KS', 'Kansas'], ['KY', 'Kentucky'], ['LA', 'Louisiana'], ['ME', 'Maine'],
    ['MD', 'Maryland'], ['MA', 'Massachusetts'], ['MI', 'Michigan'], ['MN', 'Minnesota'],
    ['MS', 'Mississippi'], ['MO', 'Missouri'], ['MT', 'Montana'], ['NE', 'Nebraska'],
    ['NV', 'Nevada'], ['NH', 'New Hampshire'], ['NJ', 'New Jersey'], ['NM', 'New Mexico'],
    ['NY', 'New York'], ['NC', 'North Carolina'], ['ND', 'North Dakota'], ['OH', 'Ohio'],
    ['OK', 'Oklahoma'], ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'],
    ['SC', 'South Carolina'], ['SD', 'South Dakota'], ['TN', 'Tennessee'], ['TX', 'Texas'],
    ['UT', 'Utah'], ['VT', 'Vermont'], ['VA', 'Virginia'], ['WA', 'Washington'],
    ['WV', 'West Virginia'], ['WI', 'Wisconsin'], ['WY', 'Wyoming']
  ];

  CRP.isState = function (code) {
    return CRP.STATES.some(function (s) { return s[0] === code; });
  };

  /* Fills a <select> only if the markup did not already ship the options. */
  CRP.stateOptions = function (select) {
    var el = typeof select === 'string' ? d.getElementById(select) : select;
    if (!el || el.options.length > 1) { return el; }
    CRP.STATES.forEach(function (s) {
      var o = d.createElement('option');
      o.value = s[0];
      o.textContent = s[1];
      el.appendChild(o);
    });
    return el;
  };

  CRP.nowISO = function () { return new Date().toISOString(); };

  w.CRP = CRP;
})(window, document);
